import React, {Component} from 'react';
import ViewRenderer from './views';
import {API} from '../../../requests';
import 'react-datasheet/lib/react-datasheet.css';
//import './styles.css';
import PopupContainer from '../../../components/PopupContainer';
import POPUP_CONSTANTS from '../../../constants/popup-constants';
import Spinner from '../../../components/Spinner';
import Popup from '../../../components/SimplePopup';
import Popupcan from '../../../components/PopupPerson/popup';
import {editFormData} from './editData';
import strings from '../../../globalization';
import util from '../../../util';
import {getFormData} from './data';
import DeletePopup from '../../../components/DeletePopup';
import {commonImages, operatorImages} from '../../../assets/images';
class PersonType extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: undefined,
      searchText: '',
      personType: [],
      singlePersonType: [],
      filterPersonType: [],

      selectedStatus: '',
    };
  }
  statuses = [
    {
      id: '',
      name: 'ALL',
    },
    {
      id: 'inactive',
      name: 'INACTIVE',
    },
    {
      id: 'active',
      name: 'ACTIVE',
    },
  ];
  editStatusDropDown = this.statuses.filter(num => num.id !== '');

  onSubmit = personType => {
    const personTypeData = {
      name: personType.name.value,
      name_hindi: personType.name_hindi.value,
    };
    this.setState({
      popup: null,
    });
    this.savePersonType(personTypeData);
  };
  showErrorPopup = errorMsg => {
    this.setState({
      popup: {
        type: POPUP_CONSTANTS.SIMPLE_POPUP,
        message: errorMsg,
        messageStyle: {color: '#E67717'},
        headingImage: commonImages.errorIcon,
        buttons: [
          {
            text: strings.okayPopup,
            onClick: this.onClose,
          },
        ],
        onClose: this.onClose,
      },
    });
  };
  showSuccessPopup = (successMessage, onClick) => {
    this.setState({
      popup: {
        type: POPUP_CONSTANTS.SIMPLE_POPUP,
        message: successMessage,
        onClose: this.onClose,
        headingImage: operatorImages.successIcon,
        buttons: [
          {
            text: strings.okayPopup,
            onClick: onClick ? onClick : this.onClose,
            outline: true,
          },
        ],
      },
    });
  };

  onClickHandler = (action, data) => {
    switch (action) {
      case 'edit': {
        this.setState({
          popup: {
            type: POPUP_CONSTANTS.EDIT_POPUP,
          },
          singlePersonType: data,
        });

        break;
      }
      case 'delete': {
        data.status === 'ACTIVE' &&
          this.setState({
            personType: data,
            popup: {type: POPUP_CONSTANTS.DELETE_POPUP},
          });

        break;
      }
      default: {
        break;
      }
    }
  };
  onClose = () => {
    this.setState({
      popup: null,
    });
  };
  tableActionHandler = (action, data) => {
    switch (action) {
      case 'status': {
        this.setState(
          {
            selectedStatus: data,
          },
          this.applyFilters,
        );
        break;
      }

      case 'addNewPerson': {
        this.setState({
          popup: {
            type: POPUP_CONSTANTS.ADD_DATA_POPUP,
          },
        });
        break;
      }

      case 'search': {
        this.setState(
          {
            searchText: data,
          },
          this.applyFilters,
        );
        break;
      }
      case 'clearFilter': {
        this.setState({
          searchText: '',
          selectedStatus: '',
        });
        this.fetchPersonType();

        break;
      }
      default: {
        console.info('tableActionHandler case not handled', action);
      }
    }
  };
  onEditHandler = data => {
    let myData = {
      id: this.state.singlePersonType.id,
      name: data.name.value,
      name_hindi: data.name_hindi.value,
      status: data.status.value.toUpperCase(),
    };
    this.setState({popup: null});
    this.updatePersonType(myData);
  };

  fetchPersonType = async () => {
    this.setState({popup: {type: POPUP_CONSTANTS.SPINNER_POPUP}});
    API.fetchPersonTypeData()
      .then(res => {
        this.setState(
          {
            // ...this.state,
            personType: res.data,
            filterPersonType: res.data,
            popup: null,
          },
          this.applyFilters,
        );
      })
      .catch(err => {
        const error = util.getErrorMessage(err);
        this.showErrorPopup(error);
      });
  };
  savePersonType = personTypeName => {
    let formData = {
      name: personTypeName.name,
      name_hindi: personTypeName.name_hindi,
      status: personTypeName.status,
    };

    API.savePersonTypeData(formData)
      .then(res => {
        this.showSuccessPopup(
          ' Person Type Added Successfully',
          this.fetchPersonType,
        );
      })
      .catch(error => {
        const err = util.getErrorMessage(error);
        this.showErrorPopup(err);
      });
  };
  deletePersonTypeData = id => {
    API.deletePersonType(id)
      .then(res => {
        this.showSuccessPopup(
          'Person Type Deleted Successfully',
          this.fetchPersonType,
        );
      })
      .catch(error => {
        const err = util.getErrorMessage(error);
        this.showErrorPopup(err);
      });
  };
  updatePersonType = data => {
    API.updatesPersonTypeData(data)
      .then(res => {
        this.showSuccessPopup(
          'Person Type Updated Successfully',
          this.fetchPersonType,
        );
      })
      .catch(error => {
        const err = util.getErrorMessage(error);
        this.showErrorPopup(err);
      });
  };

  getProps = () => {
    const {searchText, selectedStatus, filterPersonType} = this.state;
    return {
      onClick: this.onClickHandler,
      tableActionHandler: this.tableActionHandler,
      personType: filterPersonType,
      statuses: this.statuses,
      searchText,
      selectedStatus,
    };
  };

  applyFilters = () => {
    const {searchText, selectedStatus, personType} = this.state;
    const filteredData =
      personType.length > 0 &&
      personType.filter(row => {
        const name = {name: row.name, name_hindi: row.name_hindi};
        //console.log('myNmwe', Object.values(name));
        // console.log('muObjectValue', Object.values(name).toString());
        if (
          searchText &&
          !Object.values(name)
            .toString()
            .toLowerCase()
            .includes(searchText.toLowerCase())
        ) {
          return false;
        }

        if (
          selectedStatus &&
          row.status.toLowerCase() !== selectedStatus.toLowerCase()
        ) {
          return false;
        }
        return true;
      });

    console.info('filteredData', filteredData, selectedStatus);

    this.setState({
      filterPersonType: filteredData,
    });
  };
  getPopupContent = () => {
    const {popup} = this.state;
    switch (popup.type) {
      case POPUP_CONSTANTS.ADD_DATA_POPUP: {
        return (
          <Popupcan
            header="Add"
            onSubmit={this.onSubmit}
            onClose={this.onClose}
            getFormData={getFormData}
            // statuses={this.statuses}
          />
        );
      }
      case POPUP_CONSTANTS.EDIT_POPUP: {
        return (
          <Popupcan
            header="Edit"
            categoryTypeData={this.state.singlePersonType}
            onSubmit={this.onEditHandler}
            onClose={this.onClose}
            getFormData={editFormData}
            statuses={this.editStatusDropDown}
          />
        );
      }
      case POPUP_CONSTANTS.DELETE_POPUP: {
        return (
          <DeletePopup onClick={this.onDeleteHandler} onClose={this.onClose} />
        );
      }
      case POPUP_CONSTANTS.SPINNER_POPUP: {
        return <Spinner name="cube-grid" color="#0045E6" {...popup} />;
      }
      case POPUP_CONSTANTS.SIMPLE_POPUP: {
        return <Popup {...popup} />;
      }
      default: {
        console.warn('getPopupContent', popup.type);
        return null;
      }
    }
  };
  onDeleteHandler = () => {
    let id = this.state.personType.id;
    //console.log('my delete id', id);
    this.setState({popup: null});
    this.deletePersonTypeData(id);
  };
  componentDidMount() {
    this.fetchPersonType();
  }

  render() {
    const viewProps = this.getProps();
    const {popup} = this.state;
    return (
      <>
        {popup ? (
          <PopupContainer> {this.getPopupContent()} </PopupContainer>
        ) : null}
        <ViewRenderer {...viewProps} />
      </>
    );
  }
}
export default PersonType;
